import {
  Component,
  OnDestroy,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { RequestsServices } from '../../services/requests.service';
import { UserService } from '../../services/user.service';
import { StorageService } from '../../services/storage.service';
import { PageBase } from '../../page.base';
import { ToasterService } from '../../services/toaster.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-campaigns',
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.scss'],
  providers: [ RequestsServices, StorageService, UserService ],
  encapsulation: ViewEncapsulation.None
})

export class CampaignsComponent extends PageBase implements OnDestroy {

  private companyId;
  public typeBusiness;
  public loggedAccount;
  private routeParamsSubscription: Subscription;
  public activatedRoute: string;

  constructor(private translate: TranslateService,
              private toaster: ToasterService,
              private request: RequestsServices,
              private vcr: ViewContainerRef,
              private route: ActivatedRoute,
              private router: Router,
              private storage: StorageService,
              private userService: UserService) {
    super();

    const languageCurrent = navigator.language;
    translate.addLangs(['en', 'pt-br']);
    translate.setDefaultLang('en');
    languageCurrent === 'pt-BR' ? translate.use('pt-br') : translate.use('en');

    this.loggedAccount = this.userService.getLoggedAccount();
    this.typeBusiness = this.userService.getTypeAccount();

    if (this.typeBusiness === 'company') {
      this.companyId = this.loggedAccount.id;
    } else {
      this.toaster.error('Aviso!', 'Empresa inválida.', false, 4000);
      this.router.navigate(['/home']);
    }

    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.activatedRoute = event.url;
      }
      if (event instanceof NavigationEnd) {
        this.router.navigated = false;
        this.activatedRoute = event.url;
        window.scrollTo(0, 0);
      }
    });
  }

  public ngOnDestroy(): void {
    if (this.routeParamsSubscription) {
      this.routeParamsSubscription.unsubscribe();
    }
  }

}
